import React from "react";
import CustomModal from "../../Components/Modal/CustomModal";
import CustomRoundedImage from "../../Components/CustomRoundedImage";
import NotificationIcon from "../../../Common/Svgs/NotificationIcon";
import CloseIcon from "../../../Common/Svgs/CloseIcon";
import Button from "../../Components/CustomButton";

const CannotClearModal = ({ visible, onCancel }) => {
  return (
    <CustomModal visible={visible} onCancel={onCancel} width="536px" centered>
      <div className="w-full p-4 rounded-md">
        <div className="flex items-center justify-between">
          <div className="">
            <CustomRoundedImage
              size="w-12 h-12"
              image={<NotificationIcon className="fill-none stroke-white" />}
              background="bg-alert-red"
            />
          </div>

          <button type="button" onClick={onCancel}>
            <CloseIcon className="w-6 h-6 stroke-dark-gray" />
          </button>
        </div>

        <div className="px-2 mt-5">
          <p className="text-base font-medium text-alert-red font-poppins">
            Cannot clear notifications!
          </p>
          <p className="mt-2 text-xs font-normal text-black font-aileron">
            There are pending actions which require your attention.
          </p>
        </div>

        <div className="flex justify-end gap-x-3 mt-5.5">
          <Button colors="cancelButton" size="primary" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default CannotClearModal;
